import "./styles.css";

const TrainingSummaryModal = ({ show, onClose, detail }) => {
  if (!show || !detail) return null;

  const formatDate = (dateStr) => {
    if (!dateStr) return "";

    const [day, month, year] = dateStr.split("-");
    const date = new Date(`${year}-${month}-${day}`);

    return date.toLocaleDateString("es-ES", {
      month: "long",
      day: "numeric",
      year: "numeric",
    });
  }

  const {
    class_name,
    teacher_name,
    launch_date,
    launch_time,
    training,
    training_time,
    class_type,
    intensity,
    activity_type,
    objective,
    methodology,
    heart_rate_zone,
    body_zone,
    description,
    max_records = [],
    exercises= [],
  } = detail;

  return (
    <div className="training-modal-summary training-modal-overlay">
      <div className="training-modal-main d-flex justify-content-center">
        <div className="training-modal-content position-relative d-flex flex-column justify-content-center w-100">
          <button
            className="training-modal-close position-absolute top-0 end-0 p-0 d-flex justify-content-end align-items-center"
            onClick={onClose}
            aria-label="Cerrar modal"
          >
            <i className="bi bi-x"></i>
          </button>

          <div className="training-modal-top d-flex flex-column justify-content-center gap-2">
            <span className="training-modal-title">
              Resumen del entrenamiento
            </span>
          </div>

          <div className="training-modal-top d-flex flex-column justify-content-center">
            <div className="training-modal-top d-flex flex-column justify-content-start gap-1">
              <span className="training-modal-info-label">
                Nombre de la clase
              </span>
              <span className="training-modal-label-small text-start">
                {class_name}
              </span>
            </div>
          </div>

          <div className="training-modal-info-line"></div>

          <div className="training-modal-top d-flex flex-column justify-content-center">
            <div className="training-modal-top d-flex flex-column justify-content-start gap-1">
              <span className="training-modal-info-label">
                Profesor asignado
              </span>
              <span className="training-modal-label-small text-start">
                {teacher_name}
              </span>
            </div>
          </div>

          <div className="training-modal-info-line"></div>

          {max_records.length > 0 && (
            <>
              <div className="training-modal-top d-flex flex-row justify-content-between">
                <div className="training-modal-top d-flex flex-column justify-content-start gap-1">
                  <span className="training-modal-info-label">
                    Nombre del récord
                  </span>
                  <span className="training-modal-label-small text-start">
                    {max_records[0].name}
                  </span>
                </div>
                <div className="training-modal-info-line-vertical"></div>
                <div className="training-modal-top d-flex flex-column justify-content-start gap-1">
                  <span className="training-modal-info-label">
                    Unidad de medida
                  </span>
                  <span className="training-modal-label-small text-start">
                    {max_records[0].unit_measurement}
                  </span>
                </div>
              </div>

              <div className="training-modal-info-line"></div>

              <div className="training-modal-top d-flex flex-row justify-content-between">
                <div className="training-modal-top d-flex flex-column justify-content-start gap-1">
                  <span className="training-modal-info-label">
                    Métrica de tiempo
                  </span>
                  <span className="training-modal-label-small text-start">
                    {exercises.is_time_metric ? "Sí" : "No"}
                  </span>
                </div>
                <div className="training-modal-info-line-vertical"></div>
                <div className="training-modal-top d-flex flex-column justify-content-start gap-1">
                  <span className="training-modal-info-label">
                    Métrica inversa
                  </span>
                  <span className="training-modal-label-small text-start">
                    {exercises.is_inverse_metric ? "Sí" : "No"}
                  </span>
                </div>
              </div>
            </>
          )}

          <div className="training-modal-table d-flex flex-column justify-content-center mb-3 p-3">
            <span className="training-modal-label fw-bold mb-2">
              Información Avanzada
            </span>

            <div className="training-modal-info-line mb-3"></div>

            {[
              ["Entrenamiento", training],
              ["Tiempo", training_time],
              ["Tipo de Clase", class_type],
              ["Intensidad", intensity],
              ["Tipo de Actividad", activity_type],
              ["Objetivo", objective],
              ["Metodología", methodology],
              ["Zona de frecuencia cardíaca", heart_rate_zone],
              ["Zona corporal de trabajo", body_zone],
            ].map(([label, value]) => (
              <div className="training-modal-info-row" key={label}>
                <div className="training-modal-info-cell">
                  <div className="training-modal-info-label">{label}</div>
                </div>
                <div className="training-modal-info-cell">
                  <div className="training-modal-info-label">
                    {value || "No aplica"}
                  </div>
                </div>
              </div>
            ))}
          </div>

          {description && (
            <>
              <div className="training-modal-info-line"></div>
              <div className="training-modal-bottom d-flex flex-column justify-content-center gap-2">
                <span className="training-modal-label fw-bold mb-2">
                  Descripción
                </span>
                <div className="training-modal-description">{description}</div>
              </div>
            </>
          )}

          <div className="training-modal-info-line"></div>

          <div className="training-modal-top d-flex flex-row justify-content-between">
            <div className="training-modal-top d-flex flex-column justify-content-start gap-1">
              <span className="training-modal-info-label">
                Fecha de lanzamiento
              </span>
              <span className="training-modal-label-small text-start">
                {formatDate(launch_date)}
              </span>
            </div>
            <div className="training-modal-info-line-vertical"></div>
            <div className="training-modal-top d-flex flex-column justify-content-start gap-1">
              <span className="training-modal-info-label">
                Hora de publicación
              </span>
              <span className="training-modal-label-small text-start">
                {launch_time}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrainingSummaryModal;
